import { CountryObj } from './types';

export function mapAndSortCountries(
  countryCodes: any, // Todo: Tim: Fix type
  countryDetails: any // Todo: Tim: Fix type
): CountryObj[] {
  const countriesInfo: CountryObj[] = [];
  if (countryCodes) {
    countryCodes.map((countryCode: any) => { // Todo: Tim: Fix type
      if (countryCode && countryDetails[countryCode]) {
        countriesInfo.push(countryDetails[countryCode]);
      }
    });
  }
  return countriesInfo
    ? countriesInfo.sort((a, b) => a.name.localeCompare(b.name))
    : countriesInfo;
}

export function langSpecificEnums(data: any, enumsObj: any) {
  return data.map((d: any) => {
    const enumItem = enumsObj[d.name];
    if (enumItem) {
      const items = d.items.map((di: any) => {
        const enumvalueItem = enumItem[di.value];
        if (enumvalueItem) {
          di = { ...di, description: enumvalueItem };
        }
        return di;
      });
      d = { ...d, items };
    }
    return d;
  });
}